/**
 * Lazy import utilities for large dependencies
 * Reduces initial bundle size by loading libraries only when needed
 */

/**
 * Dynamically import ExcelJS for Excel file generation
 * Only loads the library when user triggers export
 */
export async function loadExcelJS() {
  const ExcelJS = await import('exceljs');
  return ExcelJS;
}

/**
 * Dynamically import html2canvas for screenshot generation
 * Only loads the library when user triggers screenshot
 */
export async function loadHtml2Canvas() {
  const html2canvas = await import('html2canvas');
  return html2canvas.default;
}

/**
 * Dynamically import AWS SDK S3 client
 * Only loads when actually interacting with S3 (if FORCE_S3 is enabled)
 */
export async function loadAwsS3() {
  const { S3Client } = await import('@aws-sdk/client-s3');
  return { S3Client };
}
